import { render, staticRenderFns } from "./detail.dialog.vue?vue&type=template&id=71d153d9&scoped=true"
import script from "./detail.dialog.vue?vue&type=script&lang=js"
export * from "./detail.dialog.vue?vue&type=script&lang=js"
import style0 from "./detail.dialog.vue?vue&type=style&index=0&id=71d153d9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d153d9",
  null
  
)

export default component.exports